<div class="rating">
  <div
    class="star"
    [ngClass]="{ off: (i + 1) > rating }"
    *ngFor="let r of [].constructor(5); let i = index"
  ></div>
</div>
